import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import React from "react";
const AbEllipsisAnimation = (props, ref) => /*#__PURE__*/React.createElement("div", _extends({}, ReactUtils.componentProps("ab-ellipsis-animation", props), {
  "data-test-component": "ab-busy-indicator",
  ref: ref
}), /*#__PURE__*/React.createElement("div", {
  className: "ab-ellipsis-animation-dot"
}), /*#__PURE__*/React.createElement("div", {
  className: "ab-ellipsis-animation-dot"
}), /*#__PURE__*/React.createElement("div", {
  className: "ab-ellipsis-animation-dot"
}));
const WrappedAbEllipsisAnimation = /*#__PURE__*/React.forwardRef(AbEllipsisAnimation);
export { WrappedAbEllipsisAnimation as AbEllipsisAnimation };
//# sourceMappingURL=AbEllipsisAnimation.js.map
